module.exports = "<div class=\"legal-container\">\n  <h2>{{messageTypeDisplay}}</h2>\n  <hr />\n\n  <div class=\"legal-display\">\n    <div class=\"legal-message\" ng-bind-html=\"message\"></div>\n  </div>\n\n  <div class=\"legal-button-container\">\n    <button class=\"btn btn-primary\" ng-click=\"acceptLegal()\">Accept</button>\n    <button class=\"btn btn-danger\" ng-click=\"declineLegal()\">Decline</button>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/legal-message/app/template/legal-message-display.html
// module id = 450
// module chunks = 0